import { HttpRequest, HttpHandlerFn, HttpEvent, HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
 
export const myHttpInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  // Clone the request to add the new header
  const headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
 
  const mergedHeaders = req.headers.keys().reduce((headers, key) => {
    return headers.set(key, req.headers.get(key) as string);
  }, headers);
  const authReq = req.clone({ headers: mergedHeaders });
 
    // Send the request with error handling
    return next(authReq).pipe(
      catchError((err) => handleError(err))
    );
  };
   
  const handleError = (error: any): Observable<never> => {
    const errorMsg = getErrorMessage(error.status);
    console.error(errorMsg, 'Error', { positionClass: 'toast-top-center' });
    return throwError(() => error);
  };
   
  const getErrorMessage = (statusCode: number): string => {
    switch (statusCode) {
      case 400:
        return 'Bad request';
      case 404:
        return 'No such resource found';
      case 500:
        return 'An unknown server error has occurred';
      default:
        return 'An error occurred';
    }
  };